import React, { useRef, useState } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { DocViewer } from './DocViewer'
import { DraggableLabel } from './Draggable/Labels'
import { Button } from '../../Components/Common/Button'
import { FloatInput } from '../../Components/Common/FloatInput'
import { nanoid } from 'nanoid'
import { DraggableCard, DraggableCardElement } from './Draggable/DraggableCard'
import { Text } from '../../Components/Common/Text'
import { FC } from '../../Services'

export const MapDoc = ({
  doc, save,
  labelElements: [labelElements, setLabelElements] = [[], () => {}],
  dateElements: [dateElements, setDateElements] = [[], () => {}],
  pageNumber: [pageNumber, setPageNumber] = [0, () => {}],
  conditionalElements: [conditionalElements, setConditionalElements] = [[], () => {}],
  imageElements: [imageElements, setImageElements] = [[], () => {}]
}) => {
  const refContainer = useRef(null)
  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 })

  const draggableProps = { pageNumber, parentRef: refContainer, pdfDimensions }
  return (
    <Flex fw>
      <Flex js as row fw>
        <DocViewer pageNumber={[pageNumber, setPageNumber]} doc={doc} pdfDimensions={[pdfDimensions, setPdfDimensions]} />
        <div ref={refContainer} style={{ width: pdfDimensions?.width, height: pdfDimensions?.height, position: 'absolute', zIndex: 20, border: '1px solid red', marginTop: 65 }}>
          <DraggableLabel listState={[labelElements.filter(({ hide }) => !hide), setLabelElements]} {...draggableProps} />
          <DraggableLabel listState={[conditionalElements.filter(({ hide }) => !hide), setConditionalElements]} {...draggableProps} />
          <DraggableLabel listState={[imageElements.filter(({ hide }) => !hide), setImageElements]} {...draggableProps} />
          <DraggableLabel listState={[dateElements.filter(({ hide }) => !hide), setDateElements]} {...draggableProps} />
        </div>
        <Flex fw style={{ marginLeft: 20 }}>
          <DraggableCard onAdd={(data) => setLabelElements([...labelElements, { coefficientX: 0, coefficientY: 0, page: pageNumber, id: nanoid(), elements: [{ jsonKey: '', fixedValue: null, letterSpacing: 0 }] }])} label='Etichette'>
            {labelElements.map((element, index) => (
              <DraggableCardElement
                key={index} id={element.id}
                hide={element.hide}
                deleteElement={() => setLabelElements(labelElements.filter((el, i) => i !== index))}
                copyElement={() => setLabelElements([...labelElements, { ...element, id: nanoid() }])}
                hideElement={() => setLabelElements(labelElements.map((el, i) => i === index ? { ...el, hide: !el.hide } : el))}
              >
                <Button label='Aggiungi concatenazione' onClick={() => setLabelElements(labelElements.map((el, i) => i === index ? { ...el, elements: [...el?.elements || [], { jsonKey: '', fixedValue: null, letterSpacing: 0 }] } : el))} style={{ marginBottom: 20, marginTop: 10 }} />
                {(element?.elements || [])?.map((key, i) => (
                  <Flex fw row key={i}>
                    <FloatInput
                      value={[key.jsonKey || '', (data) => setLabelElements(labelElements.map((el, j) => j === index ? { ...el, elements: el.elements.map((c, k) => k === i ? { ...c, jsonKey: data, fixedValue: null } : c) } : el))]}
                      style={{ width: '33.3%', marginRight: 10 }} label='Chiave' readOnly={key.fixedValue}
                    />
                    <FloatInput
                      value={[key.fixedValue || '', (data) => setLabelElements(labelElements.map((el, j) => j === index ? { ...el, elements: el.elements.map((c, k) => k === i ? { ...c, fixedValue: data, jsonKey: null } : c) } : el))]}
                      style={{ width: '33.3%', marginRight: 10 }} label='Valore Fisso' readOnly={key.jsonKey} type='multiline'
                    />
                    <FloatInput
                      value={[key.letterSpacing || 0, (data) => setLabelElements(labelElements.map((el, j) => j === index ? { ...el, elements: el.elements.map((c, k) => k === i ? { ...c, letterSpacing: data } : c) } : el))]}
                      style={{ width: '33.3%' }} label='Spaziatura' type='numeric'
                    />
                    <Button onClick={() => setLabelElements(labelElements.map((el, j) => j === index ? { ...el, elements: el.elements.filter((c, k) => k !== i) } : el))} icon='fa-duotone fa-trash' round style={{ marginLeft: 10 }} />
                    <Button
                      icon='fa-duotone fa-copy' round style={{ marginLeft: 10 }}
                      onClick={() => setLabelElements(labelElements.map((el, j) => j === index ? { ...el, elements: [...el.elements, key] } : el))}
                    />
                  </Flex>
                ))}
              </DraggableCardElement>
            ))}
          </DraggableCard>
          <DraggableCard
            onAdd={(data) => setConditionalElements([...conditionalElements, { jsonKey: '', coefficientX: 0, coefficientY: 0, page: pageNumber, id: nanoid() }])}
            label='Etichette Condizionali'
          >
            {conditionalElements.map((element, index) => (
              <DraggableCardElement
                key={index} id={element.id}
                deleteElement={() => setConditionalElements(conditionalElements.filter((el, i) => i !== index))}
                copyElement={() => setConditionalElements([...conditionalElements, { ...element, id: nanoid() }])}
              >
                <Flex js as fw>
                  <Flex row jb fw style={{ marginTop: 20 }}>
                    <Text value='Condizioni' />
                    <Button label='Nuova condizione' onClick={() => setConditionalElements(conditionalElements.map((el, i) => i === index ? { ...el, conditions: [...el?.conditions || [], { jsonKey: '', operator: '', value: '' }] } : el))} />
                  </Flex>
                  {element.conditions?.map((condition, i) => (
                    <Flex key={i} fw row style={{ marginTop: 10 }}>
                      <FloatInput value={[condition.jsonKey, (data) => setConditionalElements(conditionalElements.map((el, j) => j === index ? { ...el, conditions: el.conditions.map((c, k) => k === i ? { ...c, jsonKey: data } : c) } : el))]} style={{ width: '33.3%', marginRight: 10 }} label='Chiave' />
                      <FloatInput
                        value={[condition.operator, (data) => setConditionalElements(conditionalElements.map((el, j) => j === index ? { ...el, conditions: el.conditions.map((c, k) => k === i ? { ...c, operator: data } : c) } : el))]} style={{ width: '33.3%', marginRight: 10 }}
                        label='Operatore' type='dropdown' options={[{ label: 'Uguale', value: '=' }, { label: 'Diverso', value: '!=' }]}
                      />
                      <FloatInput value={[condition.value, (data) => setConditionalElements(conditionalElements.map((el, j) => j === index ? { ...el, conditions: el.conditions.map((c, k) => k === i ? { ...c, value: data } : c) } : el))]} style={{ width: '33.3%' }} label='Valore' />
                      <Button onClick={() => setConditionalElements(conditionalElements.map((el, j) => j === index ? { ...el, conditions: el.conditions.filter((c, k) => k !== i) } : el))} icon='fa-duotone fa-trash' round style={{ marginLeft: 10 }} />
                    </Flex>
                  ))}
                </Flex>
                <Flex js fw row style={{ marginTop: 10 }}>
                  <FloatInput
                    value={[element?.jsonKey || '', (data) => setConditionalElements(conditionalElements.map((el, i) => i === index ? { ...el, jsonKey: data, fixedValue: null, documentUrl: null } : el))]}
                    style={{ width: '33.3%', marginRight: 10 }} label='Chiave' readOnly={element.fixedValue}
                  />
                  <FloatInput
                    value={[element?.fixedValue || '', (data) => setConditionalElements(conditionalElements.map((el, i) => i === index ? { ...el, fixedValue: data, jsonKey: null, documentUrl: null } : el))]}
                    style={{ width: '33.3%', marginRight: 10 }} label='Valore Fisso' readOnly={element.jsonKey} type='multiline'
                  />
                  <Flex row style={{ width: '33.3%' }}>
                    <input
                      accept='image/*' style={{ width: 220 }}
                      type='file' onChange={(e) => {
                        const file = e.target.files[0]
                        const reader = new window.FileReader()
                        reader.onloadend = async () => {
                          const { documentUrl } = await FC.service('upload').create({ uri: reader.result })
                          setConditionalElements(conditionalElements.map((el, i) => i === index ? { ...el, documentUrl, fixedValue: null, jsonKey: null } : el))
                        }
                        reader.readAsDataURL(file)
                      }}
                    />
                    {element.documentUrl &&
                      <>
                        <a href={element.documentUrl} target='_blank' rel='noreferrer' style={{ margin: '0 10px' }}>Apri</a>
                        <FloatInput value={[element.height, (data) => setConditionalElements(conditionalElements.map((el, i) => i === index ? { ...el, height: data } : el))]} label='Altezza' type='numeric' />
                      </>}
                  </Flex>
                </Flex>
              </DraggableCardElement>
            ))}
          </DraggableCard>
          <DraggableCard
            label='Immagini'
            onAdd={(data) => setImageElements([...imageElements, { jsonKey: '', coefficientX: 0, coefficientY: 0, page: pageNumber, id: nanoid(), height: 45 }])}
          >
            {imageElements.map((element, index) => (
              <DraggableCardElement
                key={index} id={element.id}
                deleteElement={() => setImageElements(imageElements.filter((el, i) => i !== index))}
                copyElement={() => setImageElements([...imageElements, { ...element, id: nanoid() }])}
              >
                <Flex js fw row>
                  <input
                    accept='image/*' style={{ width: 220 }}
                    type='file' onChange={(e) => {
                      const file = e.target.files[0]
                      const reader = new window.FileReader()
                      reader.onloadend = async () => {
                        const { documentUrl } = await FC.service('upload').create({ uri: reader.result })
                        setImageElements(imageElements.map((el, i) => i === index ? { ...el, documentUrl } : el))
                      }
                      reader.readAsDataURL(file)
                    }}
                  />
                  {element.documentUrl &&
                    <>
                      <a href={element.documentUrl} target='_blank' rel='noreferrer' style={{ margin: '0 10px' }}>Apri</a>
                      <FloatInput
                        value={[element.height, (data) => setImageElements(imageElements.map((el, i) => i === index ? { ...el, height: data } : el))]}
                        style={{ width: '100%' }} label='Altezza' type='numeric'
                      />
                    </>}
                </Flex>
              </DraggableCardElement>
            ))}
          </DraggableCard>
          <DraggableCard onAdd={(data) => setDateElements([...dateElements, { coefficientX: 0, date: 'today', coefficientY: 0, page: pageNumber, id: nanoid() }])} label='Date'>
            {dateElements.map((element, index) => (
              <DraggableCardElement
                key={index} id={element.id}
                deleteElement={() => setDateElements(dateElements.filter((el, i) => i !== index))}
                copyElement={() => setDateElements([...dateElements, { ...element, id: nanoid() }])}
              >
                <Text value='Data' />
              </DraggableCardElement>
            ))}
          </DraggableCard>
        </Flex>
      </Flex>
      <Flex row>
        <Button label='Salva' onClick={save} />
      </Flex>
    </Flex>
  )
}
